/** ACC20C02 取引先登録・編集 — section definitions. */

export const COMPANY_SECTION_TITLE = {
  basicInfo: "基本情報",
  billingRecipient: "請求先情報",
  internalStaff: "社内担当者・連携設定",
  billingTiming: "請求タイミング設定",
  otherInfo: "その他情報",
} as const;

export const COMPANY_SECTION_ID = {
  basicInfo: "company-basic-info",
  billingRecipient: "company-billing-recipient",
  internalStaff: "company-internal-staff",
  billingTiming: "company-billing-timing",
  otherInfo: "company-other-info",
} as const;

/** Design measurements: two columns total 1134px = nav 258 + gap 24 + content 852. */
export const COMPANY_LAYOUT_WIDTH = 1134;
export const COMPANY_NAV_WIDTH = 258;
export const COMPANY_CONTENT_WIDTH = 852;
export const COMPANY_COLUMN_GAP = 24;

export const COMPANY_PAGE_TITLE_CREATE = "新規取引先作成";

/** Format hint of every 郵便番号 input — the lookup fires as soon as it matches. */
export const ZIP_CODE_PLACEHOLDER = "999-9999";

/** 都道府県 / 市区町村 are filled by the 郵便番号 lookup only — never typed in. */
export const AUTO_FILLED_PLACEHOLDER = "自動入力内容 (readonly)";

/** Empty state of the 請求先情報 table (Take9 §2 forbids 「事業者」; wording pending confirmation). */
export const BILLING_RECIPIENT_EMPTY_TEXT = "事業者・営業所が登録されていません";

export const BILLING_GROUPING_TOOLTIP =
  "合算：人材紹介料の自動明細を繰り返し請求に統合させます。\n分離：人材紹介料の自動明細を独立した請求として生成します。\n\n2点とも手動明細には影響しません。";

export const INVOICE_DATE_OFFSET_TOOLTIP = "対象月に対して請求をずらして設定できます。未設定の場合は組織設定登録情報に準拠します。";

export const PAYMENT_DUE_OFFSET_TOOLTIP = "対象月に対して支払期日をずらして設定できます。未設定の場合は組織設定登録情報に準拠します。";

export const LEAVE_CONFIRM_MESSAGE = "現在入力中の内容が破棄されますがよろしいですか？";
